import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useRef, useState } from 'react';
import { Box, Button, FormHelperText, Popover } from '@mui/material';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import { ChromePicker } from 'react-color';
import { useController } from 'react-hook-form';
import JoveTextField from '../textField/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveColorPicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      limitWithNormalWidth = props.limitWithNormalWidth,
      value = props.value,
      valueChange = props.valueChange,
      error = props.error,
      errMessage = props.errMessage,
      disabled = props.disabled;

  var _useState = useState(''),
      selectColorValue = _useState[0],
      setSelectColorValue = _useState[1];

  var _useState2 = useState(null),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(null),
      anchorElId = _useState3[0],
      setAnchorElId = _useState3[1];

  var uniqueElId = useRef(uniqueId());

  var _useState4 = useState(''),
      originColor = _useState4[0],
      setOriginColor = _useState4[1];
  /**
   * effects
   */


  useEffect(function () {
    setSelectColorValue(value);
    setOriginColor(value);
  }, [value]);
  /**
   * methods
   */

  var emitColorValue = function emitColorValue(color) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(color);
  };

  var colorChangeAction = function colorChangeAction(item) {
    setSelectColorValue(item === null || item === void 0 ? void 0 : item.hex);
  };

  var openColorPickerAction = function openColorPickerAction(event) {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
      setAnchorElId(uniqueElId.current);
    }
  };

  var closePopoverAction = function closePopoverAction() {
    setAnchorEl(null);
    setAnchorElId(null);
    setSelectColorValue(originColor);
  };

  var confirmAction = function confirmAction() {
    setOriginColor(selectColorValue);
    emitColorValue(selectColorValue);
    setTimeout(function () {
      closePopoverAction();
    }, 0);
  };

  var containerHeight = size === 'small' ? 24 : size === 'large' ? 56 : 40;
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    style: {
      height: containerHeight
    },
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center space-x-2",
      children: [/*#__PURE__*/_jsx(Box, {
        className: "cursor-pointer rounded-md border border-[#0000003A]",
        style: {
          height: containerHeight,
          width: containerHeight,
          backgroundColor: originColor || 'transparent'
        },
        onClick: openColorPickerAction
      }), /*#__PURE__*/_jsx(JoveTextField, {
        className: clsx(limitWithNormalWidth ? 'w-[160px]' : 'flex-1'),
        size: "small",
        prefixText: "#",
        value: (value || '').replace('#', ''),
        disabled: disabled
      })]
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    }), anchorEl && /*#__PURE__*/_jsx(Popover, {
      id: anchorElId,
      open: true,
      anchorEl: anchorEl,
      onClose: closePopoverAction,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      children: /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col",
        children: [/*#__PURE__*/_jsxs(Box, {
          className: "my-2 flex flex-row items-center justify-between px-2",
          children: [/*#__PURE__*/_jsx(Box, {
            className: "h-6 w-6 rounded-full",
            style: {
              backgroundColor: selectColorValue || 'transparent'
            }
          }), /*#__PURE__*/_jsx(Button, {
            size: "small",
            variant: "contained",
            onClick: confirmAction,
            children: "Confirm"
          })]
        }), /*#__PURE__*/_jsx(ChromePicker, {
          color: selectColorValue,
          onChangeComplete: colorChangeAction
        })]
      })
    })]
  });
});
export var JoveColorPickerControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveColorPicker, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: onChange,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveColorPicker;